import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import validator from 'validator';
import { requestOTP } from '../services/user';
import LogoWhite from '../assets/svg/brand/logo-white.svg';

const LoginOTP = (props) => {
    const [error, setError] = useState(false);
    const [email, setEmail] = useState('');

    useEffect(() => {
        document.title = 'Grisino Fan - Ingresá con código';
    }, []);

    useEffect(() => {
        if (props.auth) {
            props.history.push('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.auth]);

    const submit = async (event) => {
        event.preventDefault();
        setError(false);

        // El backend busca el email tal cual en /otp/request, así que lo normalizamos acá
        const normalizedEmail = email.trim().toLowerCase();

        if (!normalizedEmail || !validator.isEmail(normalizedEmail)) {
            return errorHandler(0);
        }

        try {
            const result = await requestOTP(normalizedEmail);
            if (!result.success) {
                // El rate limiter responde con un string en vez de { error }
                return errorHandler(typeof result === 'string' ? result : result.error);
            }
            props.history.push({
                pathname: '/verificar-codigo',
                search: props.location.search,
                state: { email: normalizedEmail },
            });
        } catch (e) {
            return errorHandler(e.status);
        }
    };

    const errorHandler = (status) => {
        let text = '';
        switch (status) {
            case 0:
                text = 'Por favor, ingresá un email válido.';
                break;
            case 'User not found':
                text = 'El email ingresado no corresponde a un usuario activo.';
                break;
            case 'Failed to send OTP email':
                text = 'No pudimos enviarte el código. Inténtalo más tarde.';
                break;
            case 'Too many requests, please try again later.':
                text = 'Hiciste demasiados intentos. Esperá unos minutos y volvé a intentar.';
                break;
            default:
                text = 'Hubo un problema. Inténtalo más tarde.'
                break;
        }
        return setError(text);
    };

    return (
        <div className="signup-template">
            <div className="position-absolute top-0 start-0 p-4 p-md-5 w-100">
                <span className="ps-lg-3">
                    <img src={LogoWhite} alt="Grisino Fan" className="brand-icon-lg" />
                </span>
            </div>
            <div className="row g-0 align-items-center">
                <div className="col-lg-7 bg-black">
                    {
                        props.assets.signin_cover_web && <img src={props.assets.signin_cover_web} className="cover-fit" alt="Sign in Cover" />
                    }
                </div>
                <div className="col-lg-5 px-md-3 px-xl-5">
                    <div className="px-3 py-4 p-md-5 p-xxl-5 mx-xxl-4">
                        <div className="login-form py-2 py-md-0 mx-auto mx-lg-0">
                            <h2 className="h1 mb-3">Ingresá con código</h2>
                            <p className="text-gray-700">Te vamos a enviar un código de verificación a tu email.</p>
                            <form className="pt-2" onSubmit={submit}>
                                <div className="mb-4 pb-md-2">
                                    <label className="form-label form-label-lg" htmlFor="email">Email</label>
                                    <input type="email" className="form-control form-control-xl" id="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                </div>
                                <div className="d-grid">
                                    {error && <p className="text-danger fw-bold">{error}</p>}
                                    <button type="submit" className="btn btn-xl btn-primary">Enviar</button>
                                </div>
                                <div className="my-4 d-flex pb-3">
                                    <NavLink to="/ingresa" className="small text-gray-600 ms-auto mt-1">Ingresar con contraseña</NavLink>
                                </div>
                                <div className="border-top border-gray-200 pt-4">
                                    <span className="text-gray-700">¿No tenés cuenta? <NavLink to="/registrate" className="link-primary">Registrate</NavLink></span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    auth: state.auth.isAuthenticated,
    assets: state.assets,
});

export default connect(mapStateToProps)(LoginOTP);
